/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TrackingOrderAccess } from './tracking_order_access'
import type { TrackingOrderCargo } from './tracking_order_cargo'
import type { TrackingOrderPoint } from './tracking_order_point'
/**
 * Информация о заявке
 */
export type TrackingOrder = {
  departure: TrackingOrderPoint
  destination: TrackingOrderPoint
  cargo: TrackingOrderCargo
  /**
   * Статус оплаты заявки
   */
  paymentStatus: TrackingOrder.paymentStatus
  /**
   * Возможна ли оплата заявки по счету
   */
  payableByInvoice: boolean
  access: TrackingOrderAccess
}
export namespace TrackingOrder {
  /**
   * Статус оплаты заявки
   */
  export enum paymentStatus {
    NO = 'no',
    PART = 'part',
    FULL = 'full'
  }
}
